import { ThumbUp as ThumbUpIcon } from '@mui/icons-material';

const ThumbUp = (): JSX.Element => <ThumbUpIcon fontSize="inherit" />;

export default ThumbUp;
